'use client'

import dynamic from 'next/dynamic'
import type { FeaturesSection } from '@/payload-types'

const ClientFeaturesSection = dynamic(() => import('./ClientFeaturesSection'))

type Props = Pick<FeaturesSection, 'title' | 'description' | 'features'>

const ClientWrapper = ({ title, description, features }: Props) => {
  return <ClientFeaturesSection title={title} description={description} features={features} />
}

export default ClientWrapper
